import axios from "axios";

export const getRole = ({serverURL, setRole, getToken}:any) => {
  try {
    
    getToken()?.then((token: string | null) => {
      if (!token) {
        setRole("user");
        return;
      }

      axios
        .post(
          `${serverURL}/userRole`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res:any) => {
          setRole(res.data.role);
        })
        .catch((err) => {
          console.error("Role fetch error:", err.response?.status, err.response?.data);
          setRole("user");
        });
    }).catch((err: any) => {
      console.error("[getRole] getToken() error:", err);
      setRole("user");
    });
  } catch (err) {
        console.error("[getRole] Exception:", err);
      }
}